(ns frontend.ui.component.lp-portal.report.body.private-equity.fund.natural-capital.pdf-pages.page-3 
  (:require [frontend.ui.component.chart.view :as chart-view]
            [frontend.ui.component.lp-portal.page.pdf.view :as page]
            [frontend.ui.component.lp-portal.report.body.private-equity.fund.natural-capital.titles :as titles]
            [frontend.ui.component.lp-portal.voima-components.pdf.card.view :as card]
            [frontend.ui.component.lp-portal.voima-components.pdf.column.view :as column]
            [potpuri.core :as potpuri]))

(defn portfolio-allocation
  [{:keys [portfolio-allocation language]}]
  [(card/first-row-first-column-card
    (titles/resolve-dasos-titles-with-lang :portfolio-allocation language)
    false
    {:svg (chart-view/chart-svg "highcharts"
                                (potpuri/deep-merge (:figures portfolio-allocation)
                                                    {:chart  {:width   550
                                                              :height  320
                                                              :spacing [10 0 0 0]
                                                              :margin  [-20 0 0 0]}
                                                     :legend {:verticalAlign "bottom"
                                                              :align         "center"
                                                              :floating      true
                                                              :padding       5}}))
     :fit [page/half-page-without-margins (- (/ page/page-height 2) 70)]})])

(defn portfolio-fair-value-by-country
  [{:keys [portfolio-by-country-fair-value language]}]
  [(card/second-row-first-column-card
    (titles/resolve-dasos-titles-with-lang :portfolio-by-country-fair-value language)
    false
    {:svg (chart-view/chart-svg "highcharts"
                                (potpuri/deep-merge (:figures portfolio-by-country-fair-value)
                                                    {:chart  {:width   550
                                                              :height  320
                                                              :spacing [10 0 0 0]
                                                              :margin  [-20 0 0 0]}
                                                     :legend {:verticalAlign "bottom"
                                                              :align         "left"
                                                              :floating      true
                                                              :padding       10}}))
     :fit [page/half-page-without-margins (- (/ page/page-height 2) 70)]})])

(defn investments-map-svg
  [{:keys [investments-map language]}]
  (let [config (potpuri/deep-merge (:figures investments-map)
                                   {:chart   {:width   500
                                              :height  600
                                              :spacing [10 0 0 0]
                                              :margin  [0 20 0 0]}
                                    :mapView {:projection {:name "WebMercator"}
                                              :center     [6 57]
                                              :zoom       3.4}})]
    [(card/first-row-second-column-card
      (titles/resolve-dasos-titles-with-lang :investments-map language)
      false
      {:svg (chart-view/geomap-svg "highcharts" config)
       :fit [400 600]})]))

(defn view
  [data]
  (page/page
   (page/page-title-with-line {:fund-name  (:fund-name data)
                               :reference-date (:reference-date data)
                               :lower-case-title? true})

   [(column/half-column
     [(portfolio-allocation data)
      (portfolio-fair-value-by-country data)]
     (investments-map-svg data))]))
